import React, { useState } from "react";
import { FaUserPlus, FaDesktop, FaMobileAlt, FaAndroid, FaMapMarkedAlt, FaShoppingCart, FaMapMarkerAlt } from "react-icons/fa";
import { FaEye, FaIdBadge, FaTags } from "react-icons/fa6";

const BuyerSetting = () => {
    const [activeTab2, setActiveTab2] = useState('web');
    const items = [
        { icon: <FaTags className="text-blue-500" />, label: "Price Tier" },
        { icon: <FaMapMarkedAlt className="text-green-500" />, label: "Territory" },
        { icon: <FaEye className="text-yellow-500" />, label: "Visibility Tier" },
        { icon: <FaShoppingCart className="text-pink-500" />, label: "Minimum Order Value" },
        { icon: <FaIdBadge className="text-purple-500" />, label: "Buyer ID" },
    ];


    const tabs = [
        { id: 'web', label: 'Web App', icon: <FaDesktop /> },
        { id: 'mobile', label: 'Mobile App', icon: <FaMobileAlt />, disabled: true },
    ];

    const renderTabs = (activeState, setActiveState) => (
        <div className="flex flex-col sm:flex-row gap-2 border-b border-[#b9ece6] sm:gap-4 mb-6">
            {tabs.map((tab) => (
                <button
                    key={tab.id}
                    onClick={() => !tab.disabled && setActiveState(tab.id)}
                    className={`flex items-center justify-center sm:justify-start gap-2 px-4 py-2 rounded-t-md transition-all text-sm w-full sm:w-auto ${activeState === tab.id
                        ? 'bg-[#1a9588] text-white shadow-md'
                        : 'bg-[#dbf4f1] text-gray-600 hover:bg-[#b9ece6] bg-gray-700 hover:bg-gray-600'
                        } ${tab.disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                    disabled={tab.disabled}
                >
                    {tab.icon}
                    {tab.label}
                </button>
            ))}
        </div>
    );
    const panels = [
        {
            icon: <FaTags className="text-blue-500 w-6 h-6" />,
            title: "Price Tier",
            description:
                "Selzor allows multiple price tiers. You can set up to 25 different prices for each product (SKU) and assign one of these prices to a specific buyer. Only the assigned price will be visible to that buyer.",
        },
        {
            icon: <FaMapMarkerAlt className="text-green-500 w-6 h-6" />,
            title: "Territory",
            description:
                "Territories connect your Sales Reps with your buyers and help you analyze orders by geographic region. Assigning a territory to a buyer links them with all Sales Reps operating in that area. This ensures your Sales Reps are notified whenever the buyer places or cancels an order.",
        },
        {
            icon: <FaEye className="text-purple-500 w-6 h-6" />,
            title: "Visibility Tier",
            description:
                "Visibility Tiers categorize your products into different levels. A buyer can only see product groups with a visibility level less than or equal to the tier assigned to them. For example, if Group A has 20 products at level 7 and Group B has 20 products at level 5, assigning a visibility tier of 6 to a buyer allows them to see only Group B products, not Group A.",
        },
        {
            icon: <FaShoppingCart className="text-yellow-500 w-6 h-6" />,
            title: "Minimum Order Value",
            description:
                "This setting enforces a minimum order amount for the buyer. If the order total is below the specified minimum, the app prompts the buyer to add more items before allowing the order to be placed.",
        },
        {
            icon: <FaIdBadge className="text-red-500 w-6 h-6" />,
            title: "Buyer ID",
            description:
                "This is the unique identifier (‘ObjectId’ or primary key) for the buyer from your existing system or database. It is used when exporting orders in JSON or XML format.",
        },
    ];


    return (
        <div className=" mx-auto p-8 bg-white rounded-3xl shadow-xl border border-gray-200">

            {/* Panel Header */}
            <div className="flex items-center gap-4 mb-6">
                <FaUserPlus className="text-pink-600 text-4xl" />
                <h1 className="text-4xl font-extrabold text-gray-900">Buyer Settings</h1>
            </div>

            {/* Tags Section */}
            <div className="flex flex-wrap items-center gap-3 mb-8">
                <span className="bg-pink-100 text-pink-700 px-3 py-1 rounded-full text-xs font-semibold">Seller</span>
                <span className="bg-yellow-100 text-yellow-700 px-3 py-1 rounded-full text-xs font-semibold">Buyer</span>
                <div className="ml-auto flex gap-2">
                    <span className="bg-blue-50 text-blue-700 px-3 py-1 rounded-full text-xs font-semibold flex items-center gap-1">
                        <FaDesktop /> Web
                    </span>
             
                    <span className="bg-green-50 text-green-700 px-3 py-1 rounded-full text-semibold text-xs flex items-center gap-1">
                        <FaAndroid /> Android
                    </span>
                </div>
            </div>

            {/* Intro */}
            <p className="text-gray-700 text-lg leading-relaxed mb-6">
                You can configure settings for each buyer individually, regardless of whether they are managed by you or manage themselves. These settings include
            </p>

            <ul className="divide-y divide-gray-200">
                {items.map((item, index) => (
                    <li
                        key={index}
                        className="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 cursor-pointer transition"
                    >
                        <span className="text-xl">{item.icon}</span>
                        <span className="text-gray-700 font-medium">{item.label}</span>
                    </li>
                ))}
            </ul>


            <div className="my-5">
                {renderTabs(activeTab2, setActiveTab2)}
                <div className="rounded-lg p-2 sm:p-4 flex justify-start">
                    <img
                        src=""
                        alt={`${activeTab2} view`}
                        className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
                    />
                </div>
            </div>

            <div className=" mx-auto p-6">
                
                <div className="grid md:grid-cols-2 gap-6">
                    {panels.map((panel, index) => (
                        <div
                            key={index}
                            className="flex items-start p-5 bg-gray-100 rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300"
                        >
                            <div className="mr-4">{panel.icon}</div>
                            <div>
                                <h2 className="text-xl font-semibold text-gray-900 mb-2">{panel.title}</h2>
                                <p className="text-gray-700">{panel.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default BuyerSetting;